import { gql } from '@apollo/client';

import { SHORT_LINK_FIELDS } from '../fragments/shortLinks';

/**
 * ТЗ 0080 — ручные короткие ссылки. Имена операций ≠ полям бэкенда
 * (`createShortLink` → `CreateManualShortLink`): иначе кодген схлопывает тип
 * результата.
 *
 * Создание, правка и погашение одной ссылки возвращают `link` тем же
 * фрагментом, что и список: ответ сам обновляет строку таблицы и карточку в
 * кэше.
 */
export const CreateManualShortLinkMutation = gql`
  mutation CreateManualShortLink(
    $targetUrl: String!
    $title: String!
    $expiresAt: DateTime
    $channel: String
    $tags: [String!]
  ) {
    createShortLink(
      targetUrl: $targetUrl
      title: $title
      expiresAt: $expiresAt
      channel: $channel
      tags: $tags
    ) {
      success
      customErrors {
        field
        code
        message
      }
      link {
        ...ShortLinkFields
      }
    }
  }
  ${SHORT_LINK_FIELDS}
`;

/**
 * Название, тип, метки и срок; `clearExpiry` делает ссылку бессрочной.
 * `channel` / `tags` = null — не менять.
 */
export const UpdateManualShortLinkMutation = gql`
  mutation UpdateManualShortLink(
    $id: ID!
    $title: String!
    $expiresAt: DateTime
    $clearExpiry: Boolean
    $channel: String
    $tags: [String!]
  ) {
    updateShortLink(
      id: $id
      title: $title
      expiresAt: $expiresAt
      clearExpiry: $clearExpiry
      channel: $channel
      tags: $tags
    ) {
      success
      customErrors {
        field
        code
        message
      }
      link {
        ...ShortLinkFields
      }
    }
  }
  ${SHORT_LINK_FIELDS}
`;

/**
 * Погасить: ссылка перестаёт открываться сразу. Свою ручную — автор, любую
 * ручную и ссылку на подпись договора — только Admin.
 */
export const RevokeManualShortLinkMutation = gql`
  mutation RevokeManualShortLink($id: ID!) {
    revokeShortLink(id: $id) {
      success
      customErrors {
        field
        code
        message
      }
      link {
        ...ShortLinkFields
      }
    }
  }
  ${SHORT_LINK_FIELDS}
`;

/**
 * Погасить выбранные (до 100 за вызов). Каждая — по своим правам: чужие и
 * уже погашенные сервер пропускает (`skipped`), а не валит всю пачку.
 * Ссылок в ответе нет — список перечитывается целиком.
 */
export const RevokeManyShortLinksMutation = gql`
  mutation RevokeManyShortLinks($ids: [ID!]!) {
    revokeShortLinks(ids: $ids) {
      success
      customErrors {
        field
        code
        message
      }
      revokedIds
      skipped
    }
  }
`;
